import { render } from "./HeroiconsOutlineExternalLink.vue?vue&type=template&id=f6f64a4a"
const script = {}

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineExternalLink.vue"]])

export default __exports__